import React, { useState, useEffect } from 'react';
import { ChevronDown, Menu, X, Sparkles, Plus, Trash2, ArrowUp, ArrowDown } from 'lucide-react';
import CategoryNav from '../components/CategoriesNav';
import axios from "axios";
import config from '../config/config';
const CategoryNavAdmin = ({ slug = '', onSave }) => {
  const token = localStorage.getItem("token");

  const CATEGORY_PRESETS = {
    'elegant-pastel': {
      label: 'Elegant Pastel',
      description: 'Soft gradients, purple-pink theme',
      customStyles: {
        backgroundColor: 'bg-white',
        textColor: '#6b21a8',
        hoverBg: 'hover:bg-purple-50',
        hoverText: 'hover:text-purple-700',
        featuredBg: 'from-purple-600 to-pink-600',
      },
    },
   /** 'dark-mystic': {
      label: 'Dark Mystic',
      description: 'Dark background with neon accents',
      customStyles: {
        backgroundColor: 'bg-gray-900',
        textColor: '#e9d5ff',
        hoverBg: 'hover:bg-purple-950',
        hoverText: 'hover:text-purple-300',
        featuredBg: 'from-purple-500 to-fuchsia-600',
      },
    },
    'vibrant-candy': {
      label: 'Vibrant Candy',
      description: 'Bright and playful colors',
      customStyles: {
        backgroundColor: 'bg-gradient-to-r from-pink-500 to-purple-600',
        textColor: '#ffffff',
        hoverBg: 'hover:bg-white/20',
        hoverText: 'hover:text-white',
        featuredBg: 'from-yellow-400 to-pink-500',
      },
    },**/
  };

  const defaultConfig = {
    preset: 'elegant-pastel',
    categories: [
      { name: 'Flowers', icon: '', submenu: ['Roses', 'Tulips', 'Orchids', 'Bouquets', 'Seasonal'], featured: false },
      { name: 'Gift Hampers', icon: '', submenu: ['Luxury', 'Gourmet', 'Spa', 'Wine & Cheese', 'Custom'], featured: false },
      { name: 'Her', icon: '', submenu: ['Jewelry', 'Perfumes', 'Handbags', 'Accessories', 'Beauty'], featured: false },
      { name: 'Him', icon: '', submenu: ['Watches', 'Grooming', 'Gadgets', 'Accessories', 'Sports'], featured: false },
      { name: 'More Gift Ideas', icon: '', submenu: ['Anniversary', 'Birthday', 'Wedding', 'Baby', 'Thank You'], featured: false },
      { name: 'Cards', icon: '', submenu: ['Birthday', 'Love', 'Congratulations', 'Sympathy', 'Blank'], featured: false },
      { name: 'Corporate Gifts', icon: '', submenu: [], featured: true },
    ],
    devMode: false,
    customStyles: {
      backgroundColor: '',
      textColor: '#6b21a8',
      hoverBg: 'hover:bg-purple-50',
      hoverText: 'hover:text-purple-700',
      featuredBg: 'from-purple-600 to-pink-600',
    },
  };

  const [preset, setPreset] = useState(defaultConfig.preset);
  const [categories, setCategories] = useState(defaultConfig.categories);
  const [devMode, setDevMode] = useState(defaultConfig.devMode);

  const [backgroundColor, setBackgroundColor] = useState(defaultConfig.customStyles.backgroundColor);
  const [textColor, setTextColor] = useState(defaultConfig.customStyles.textColor);
  const [hoverBg, setHoverBg] = useState(defaultConfig.customStyles.hoverBg);
  const [hoverText, setHoverText] = useState(defaultConfig.customStyles.hoverText);
  const [featuredBg, setFeaturedBg] = useState(defaultConfig.customStyles.featuredBg);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const loadSettings = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
         await axios.get(config.API_URL+'/sanctum/csrf-cookie', { withCredentials: true });
         const response = await axios.get(config.API_URL+`/api/pullCategoryNavSettings/${slug}`, {
           headers: { Authorization: `Bearer ${token}` },
           withCredentials: true
         });

         const dbData = response.data?.categorySettings || {};

         setPreset(dbData.preset ?? defaultConfig.preset);
         setCategories(dbData.categories ?? defaultConfig.categories);
         console.log("Categories");
          console.log(dbData.preset);

         setDevMode(dbData.devMode ?? defaultConfig.devMode);
         const styles = dbData.customStyles || {};
         setBackgroundColor(styles.backgroundColor ?? defaultConfig.customStyles.backgroundColor);
         setTextColor(styles.textColor ?? defaultConfig.customStyles.textColor);
         setHoverBg(styles.hoverBg ?? defaultConfig.customStyles.hoverBg);
         setHoverText(styles.hoverText ?? defaultConfig.customStyles.hoverText);
         setFeaturedBg(styles.featuredBg ?? defaultConfig.customStyles.featuredBg);

      } catch (err) {
        console.error("Failed to load category nav settings:", err);
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, [token, slug]);

  const saveCategoryNavSettings = async () => {
    if (!token) {
      alert("Authentication required");
      return;
    }

    setSaving(true);

    try {
       await axios.get(config.API_URL+'/sanctum/csrf-cookie', { withCredentials: true });
       const xsrfToken = document.cookie.split('; ').find(row => row.startsWith('XSRF-TOKEN='))?.split('=')[1];

      const payload = {
        settings: {
          preset,
          categories,
          devMode,
          customStyles: devMode ? {
            backgroundColor,
            textColor,
            hoverBg,
            hoverText,
            featuredBg,
          } : {},
        }
      };

       const response = await axios.post(config.API_URL+
         `/api/saveCategoryNavSettings/${slug}`,
         payload,
         {
           headers: {
             "Content-Type": "application/json",
             "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
             Authorization: `Bearer ${token}`,
           },
           withCredentials: true,
         }
       );

       if (response.data.status === 1) {
      alert("Category Navigation saved successfully! 🎉");
      if (onSave) onSave(payload.settings);
       } else {
         alert("Save failed: " + (response.data.message || "Unknown error"));
       }

    } catch (err) {
      console.error("Save error:", err);
      alert("Failed to save changes.");
    } finally {
      setSaving(false);
    }
  };

  const addCategory = () => {
    setCategories([...categories, { name: 'New Category', icon: '⭐', submenu: [], featured: false }]);
  };

  const updateCategory = (index, field, value) => {
    const updated = [...categories];
    updated[index] = { ...updated[index], [field]: value };
    setCategories(updated);
  };

  const updateSubmenuItem = (catIndex, subIndex, value) => {
    const updated = [...categories];
    updated[catIndex].submenu[subIndex] = value;
    setCategories(updated);
  };

  const addSubmenuItem = (catIndex) => {
    const updated = [...categories];
    updated[catIndex].submenu.push('New Item');
    setCategories(updated);
  };

  const removeSubmenuItem = (catIndex, subIndex) => {
    const updated = [...categories];
    updated[catIndex].submenu = updated[catIndex].submenu.filter((_, i) => i !== subIndex);
    setCategories(updated);
  };

  const removeCategory = (index) => {
    setCategories(categories.filter((_, i) => i !== index));
  };

  const moveCategory = (index, direction) => {
    if ((direction === -1 && index === 0) || (direction === 1 && index === categories.length - 1)) return;
    const newItems = [...categories];
    [newItems[index], newItems[index + direction]] = [newItems[index + direction], newItems[index]];
    setCategories(newItems);
  };

  const toggleFeatured = (index) => {
    const updated = [...categories];
    updated[index].featured = !updated[index].featured;
    setCategories(updated);
  };

  const previewConfig = {
    categories,
    customStyles: devMode ? { backgroundColor, textColor, hoverBg, hoverText, featuredBg } : CATEGORY_PRESETS[preset]?.customStyles || {},
    hideDemo: true
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <p className="text-xl text-gray-600">Loading category navigation settings...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col lg:flex-row">
      <div className="lg:w-1/2 lg:sticky lg:top-0 lg:h-screen overflow-hidden border-r border-gray-200 bg-white z-10">
        <div className="h-full flex flex-col">
          <div className="bg-white border-b px-6 py-4 shadow-sm flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">Category Navigation Editor</h1>
              <p className="text-sm text-gray-600 mt-1">Live preview – always visible</p>
            </div>
          </div>
          <div className="flex-1 overflow-auto bg-gradient-to-b from-purple-50 to-pink-50">
            <CategoryNav config={previewConfig} />
            <div className="p-10">
              <div className="text-center py-20">
                <h1 className="text-4xl font-light mb-4">Your Category Content</h1>
                <p className="text-gray-600">Categories appear above your products</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:w-1/2 lg:max-h-screen lg:overflow-y-auto">
        <div className="p-6 space-y-6">
          <div className="bg-white rounded-xl shadow-md border p-6">
            <label className="block text-lg font-semibold mb-4">Choose Design Preset</label>
            <div className="grid grid-cols-1 gap-4">
              {Object.entries(CATEGORY_PRESETS).map(([value, p]) => (
                <button
                  key={value}
                  onClick={() => setPreset(value)}
                  className={`p-4 rounded-lg border-2 text-left transition-all ${preset === value ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:border-gray-300'}`}
                >
                  <span className="font-medium">{p.label}</span>
                  <p className="text-xs text-gray-500 mt-1">{p.description}</p>
                </button>
              ))}
            </div>
          </div>

          <div className="bg-purple-50 border border-purple-200 rounded-xl p-5">
            <h3 className="font-semibold text-purple-900">
              Current Preset: {CATEGORY_PRESETS[preset]?.label || 'Custom'}
            </h3>
            <p className="text-sm text-purple-700 mt-1">
              {CATEGORY_PRESETS[preset]?.description || 'Custom category navigation'}
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-md border p-6 space-y-6">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold">Categories</h3>
              <button
                onClick={addCategory}
                className="bg-purple-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-purple-700 transition flex items-center gap-2"
              >
                <Plus size={16} /> Add Category
              </button>
            </div>

            <div className="space-y-4">
              {categories.map((cat, index) => (
                <div key={index} className="border rounded-lg p-4 bg-gray-50">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-3 flex-1">
                     {/* <input
                        value={cat.icon}
                        onChange={(e) => updateCategory(index, 'icon', e.target.value)}
                        className="w-12 text-center text-2xl border rounded p-1"
                        placeholder="🌸"
                        maxLength={2}
                      />*/}
                      <input
                        value={cat.name}
                        onChange={(e) => updateCategory(index, 'name', e.target.value)}
                        className="flex-1 px-3 py-2 border rounded-md font-medium"
                        placeholder="Category Name"
                      />
                    </div>

                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => toggleFeatured(index)}
                        className={`px-3 py-1 rounded text-sm font-medium transition ${
                          cat.featured
                            ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                      >
                        {cat.featured ? 'Featured' : 'Make Featured'}
                      </button>

                      <button
                        onClick={() => moveCategory(index, -1)}
                        disabled={index === 0}
                        className="p-2 hover:bg-gray-200 rounded disabled:opacity-40"
                      >
                        <ArrowUp size={16} />
                      </button>
                      <button
                        onClick={() => moveCategory(index, 1)}
                        disabled={index === categories.length - 1}
                        className="p-2 hover:bg-gray-200 rounded disabled:opacity-40"
                      >
                        <ArrowDown size={16} />
                      </button>
                      <button
                        onClick={() => removeCategory(index)}
                        className="p-2 text-red-600 hover:bg-red-50 rounded"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>

                  <div className="pl-4 border-l-2 border-purple-200 mt-3">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm font-medium text-gray-600">Submenu Items</span>
                      <button
                        onClick={() => addSubmenuItem(index)}
                        className="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded hover:bg-purple-200 flex items-center gap-1"
                      >
                        <Plus size={14} /> Add
                      </button>
                    </div>

                    {cat.submenu.map((item, subIdx) => (
                      <div key={subIdx} className="flex items-center gap-2 mb-2">
                        <input
                          value={item}
                          onChange={(e) => updateSubmenuItem(index, subIdx, e.target.value)}
                          className="flex-1 px-3 py-2 border rounded-md text-sm"
                        />
                        <button
                          onClick={() => removeSubmenuItem(index, subIdx)}
                          className="p-1 text-red-500 hover:bg-red-50 rounded"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-purple-50 border border-purple-200 rounded-xl p-6">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h3 className="font-semibold text-purple-900">Dev Mode – Custom Colors</h3>
                <p className="text-sm text-purple-700">Override preset colors</p>
              </div>
              <button
                onClick={() => setDevMode(!devMode)}
                className={`relative inline-flex h-6 w-11 rounded-full transition ${devMode ? 'bg-purple-600' : 'bg-gray-300'}`}
              >
                <span className={`inline-block h-4 w-4 rounded-full bg-white transition ${devMode ? 'translate-x-6' : 'translate-x-1'}`} />
              </button>
            </div>

            {devMode && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nav Background</label>
                  <input
                    value={backgroundColor}
                    onChange={(e) => setBackgroundColor(e.target.value)}
                    placeholder="bg-white or #ffffff or gradient..."
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Text Color</label>
                  <input type="color" value={textColor} onChange={(e) => setTextColor(e.target.value)} className="w-full h-10 rounded" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Featured Gradient</label>
                  <input
                    value={featuredBg}
                    onChange={(e) => setFeaturedBg(e.target.value)}
                    placeholder="from-purple-600 to-pink-600"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Hover Background Class</label>
                  <input
                    value={hoverBg}
                    onChange={(e) => setHoverBg(e.target.value)}
                    placeholder="hover:bg-purple-50"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Hover Text Color Class</label>
                  <input
                    value={hoverText}
                    onChange={(e) => setHoverText(e.target.value)}
                    placeholder="hover:text-purple-700"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>
              </div>
            )}
          </div>

          <div className="sticky bottom-0 bg-white border-t p-6 shadow-lg z-20">
            <button
              onClick={saveCategoryNavSettings}
              disabled={saving}
              className="w-full bg-purple-600 text-white py-4 rounded-xl font-bold hover:bg-purple-700 disabled:opacity-60 transition shadow-md"
            >
              {saving ? 'Saving...' : 'Save & Publish Category Navigation'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryNavAdmin;